import React from 'react';
import i18next from 'i18next';
import PunchGeolocationMap from './PunchGeolocationMap';
import Place from '@material-ui/icons/Place';
import { GetLocalApiKey } from '../../utils/companyConfig';
import { withNamespaces } from 'react-i18next';

const LocationPin = () => <div><Place color="secondary" style={{ fontSize: 30 }} /></div>;

class PunchGeolocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bounds: null,
            zoneMarker: null
        };
    }

    componentDidMount() {
    }

    isApiSet = () => {
        if (GetLocalApiKey() != null && GetLocalApiKey() != "undefined") {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <div style={{ height: 'calc(100vh - 65px)', width: '100%' }}>
                {this.isApiSet() ?
                    <PunchGeolocationMap
                        google={window.google}
                        bounds={this.state.bounds}
                        zoneMarker={this.state.zoneMarker}
                        currentPosition={this.props.currentPosition}
                        googleMapsApiKey={GetLocalApiKey()}
                        currentZone={this.props.currentZone}
                    >
                    </PunchGeolocationMap>
                    :
                    <div>{i18next.t('geolocation:message.geolocation-error')}</div>}
            </div>);
    }
};
export default withNamespaces(['punch', 'geolocation'], { wait: true })(PunchGeolocation);